export const MAXIMUM_LIMIT_ERROR_MESSAGE =
  "You've reached the maximum number of attempts. Please try to login again.";
export const UPDATED_MAXIMUM_LIMIT_ERROR_MESSAGE =
  "You've reached the maximum number of attempts. Please generate a new OTP to continue.";
export const COOKIES_ERROR =
  'Your browser may have cookies turned off. Some privacy settings or browser extensions may block cookies by default.';
